import { styled } from "@mui/material/styles";
import { TableCell, TableHead } from "@mui/material";
import { HubTableHeader } from "../../components";

export const StyledTableCell = styled(TableCell)({
  ".MuiInputBase-root, input": {
    borderRadius: 0,
    backgroundColor: "transparent",
  },
  ".MuiInputBase-root": {
    padding: "10px 12px",
  },
  ".MuiFormControl-root": {
    maxWidth: "150px",
    width: "150px",
  },
  fieldset: {
    borderWidth: 0.5,
  },
  padding: "0px !important",
  maxWidth: "150px",
  width: "150px",
  minWidth: "150px",
  height: "44.5px",
});

export const StyledPinnedColumn = styled(StyledTableCell)(({ theme }) => ({
  position: "sticky",
  left: 0,
  border: "0px !important",
  padding: "5px 12px !important",
  boxShadow: `inset -1.5px 0 ${theme.palette.hubColors.greyLight}`,
  zIndex: 100,
  maxWidth: "100%",
  width: "100%",
}));

export const StyledHubTableHeader = styled(TableHead)(({ theme }) => ({
  // backgroundColor: "hubColors.greyLighter",
  boxShadow: `inset 0 -1.5px ${theme.palette.hubColors.greyLight}`,
  zIndex: 150,
  ".MuiTableCell-root:first-child": {
    position: "sticky",
    left: 0,
    // backgroundColor: theme.palette.hubColors.greyLighter,
    border: "0px !important",
    padding: "5px 12px !important",
    boxShadow: `inset -1.5px 0 ${theme.palette.hubColors.greyLight}`,
    zIndex: 100,
  },
}));
